import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EMPTY, Observable, Subject, timer } from 'rxjs';
import { catchError, take, tap } from 'rxjs/operators';

import { Documentos } from '../_classes/documentos';
import { Provimento } from '../_classes/provimento';
import { UtilLogAcessoSistema } from '../_classes/util-log-acesso-sistema';
import { EnvService } from '../_servicos/env.service';
import { RestService } from '../_servicos/rest.service';
import { ServidorService } from '../_servicos/servidor.service';
import { ModalAjudaService } from '../shared/modal-ajuda.service';
import { ModalAlertaService } from '../shared/modal-alerta.service';
import * as CanvasJS from './../../assets/js/canvasjs.min.js';
import { PeriodoAvaliativo } from './../_classes/periodo-avaliativo';
import { Util } from './../_classes/util';

@Component({
  selector: 'app-avaliacao',
  templateUrl: './avaliacao.component.html',
  styleUrls: ['./avaliacao.component.scss'],
})
export class AvaliacaoComponent implements OnInit {
  private readonly recurso: string = 'avaliacao'; //mesmo que a rota

  // displayedColumnsP: string[] = ['periodo-e-situacaof', 'avaliacao'];
  displayedColumns: string[] = [
    'dtIniPeriodo',
    'avaliacao.dtLimiteAvaliacao',
    'avaliacao.avaliador',
    'avaliacao.nrNotaFinal',
    'docs',
  ];
  // displayedColumnsD: string[] = ['descricao', 'blob'];

  valoresMeus = [];
  valoresMin: number = 1000;
  valoresMax: number = 0;

  carregando = false;

  //servidor$: Observable<Servidor>;
  //servidor: Servidor = new Servidor();

  erros$ = new Subject<boolean>();
  dataSource$: Observable<Provimento[]>;
  dataSource: MatTableDataSource<Provimento>;

  modalRef: BsModalRef;
  config = {
    keyboard: true,
    class: 'modal-lg',
  };

  arquivoUrl: any;
  hidePdfViewer = true;

  itensAjuda = [
    { titulo: 'Período', texto: '' },
    { titulo: 'Situação', texto: 'xxx' },
    { titulo: 'Local', texto: 'xxx' },
    { titulo: 'Formato', texto: 'xxx' },
    { titulo: 'Avaliador', texto: 'xxx' },
    { titulo: 'Nota', texto: 'xxx' },
    { titulo: 'Documentos', texto: 'xxx' },
  ];

  private t: any;

  ngOnDestroy() {
    if (this.t) {
      this.t.unsubscribe();
    }
  }

  constructor(
    private service: RestService,
    private servService: ServidorService,
    private alertService: ModalAlertaService,
    private sanitizer: DomSanitizer,
    private modalService: BsModalService,
    private ajudaService: ModalAjudaService,
    private env: EnvService
  ) {}

  buscar(pTemplate: TemplateRef<any>, pI: number, pBaixar: boolean) {
    this.carregando = true;
    if (this.env.servidor) {
      this.service
        .getDocumento(pI)
        .subscribe((a) =>
          this.executarAoMostrarOuDownloadBlob(
            new Documentos(a).documentoValido(),
            pTemplate,
            pBaixar,
            new Documentos(a).nomeArquivo('')
          )
        );
    } else {
      this.carregando = false;
    }
  }

  mostrar(pTemplate: TemplateRef<any>, pI: number) {
    ////console.log('mostrar');
    this.buscar(pTemplate, pI, false);
  }

  download(pI: number) {
    ////console.log('download');
    this.buscar(null, pI, true);
  }

  nomeDoArquivo(c: Documentos): string {
    return c.nomeArquivo('avaliacao');
  }

  executarAoMostrarOuDownloadBlob(
    x: Blob,
    template: TemplateRef<any>,
    pBaixar: boolean,
    nomeDoArquivo: string
  ) {
    const blob = new Blob([Util.Base64ToBlob(x)], {
      type: 'application/pdf',
    });
    this.arquivoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      window.URL.createObjectURL(blob)
    );
    if (!pBaixar) {
      this.modalRef = this.modalService.show(template, this.config);
    } else {
      let newVariable: any = window.navigator;
      if (newVariable && newVariable.msSaveOrOpenBlob) {
        newVariable.msSaveOrOpenBlob(blob); //console.log('Carregando aterado2', this.carregando);
        return;
      }
      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const data = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = data;
      link.download = nomeDoArquivo;
      // this is necessary as link.click() does not work on the latest firefox
      link.dispatchEvent(
        new MouseEvent('click', {
          bubbles: true,
          cancelable: true,
          view: window,
        })
      );

      setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
        this.carregando = false;
      }, 1000);
    }
  }

  iniciarGrafico() {
    const chart = new CanvasJS.Chart('chart1', {
      animationEnabled: true,
      exportEnabled: true,
      culture: 'pt',
      title: {
        text: 'Gráfico de minhas avaliações',
      },
      axisY: {
        title: ' pontuação ',
        maximum: this.valoresMax + 10,
        minimum: this.valoresMin - 10,
        crosshair: {
          enabled: true,
          snapToDataPoint: true,
        },
      },
      toolTip: {
        shared: true,
      },
      axisX: {
        title: ' período avaliativo ',
        crosshair: {
          enabled: true,
        },
      },
      legend: {
        cursor: 'pointer',
        verticalAlign: 'bottom',
        horizontalAlign: 'left',
        dockInsidePlotArea: true,
        //itemclick: toogleDataSeries
      },
      data: [
        {
          type: 'line',
          showInLegend: true,
          name: 'minha avaliação',
          markerType: 'square',
          color: '#F08080',
          dataPoints: this.valoresMeus,
        },
      ],
    });
    chart.render();
  }

  periodo(dI: Date, dF: Date) {
    return Util.periodoMesAbreviado(dI, dF);
  }

  dataStr(d: Date) {
    return Util.dataMesAbrev(d);
  }

  ngOnInit() {
    this.atualizar();
  }

  /*  executarAoCarregarServidor(x: Servidor) {
    this.servidor = new Servidor(x);
  }*/

  executarAoCarregarPeriodo(x: PeriodoAvaliativo[]) {
    //console.log('carregado periodo', x);
    let item;
    this.valoresMeus = [];
    x.forEach((e) => {
      if (e.avaliacao) {
        if (e.avaliacao.nrNotaFinal) {
          if (e.avaliacao.nrNotaFinal > 0) {
            item = {
              y: e.avaliacao.nrNotaFinal,
              label: Util.periodoAno(e.dtIniPeriodo, e.dtFimPeriodo),
            };

            if (e.avaliacao.nrNotaFinal > this.valoresMax) {
              this.valoresMax = e.avaliacao.nrNotaFinal;
            }

            if (e.avaliacao.nrNotaFinal < this.valoresMin) {
              this.valoresMin = e.avaliacao.nrNotaFinal;
            }

            this.valoresMeus.push(item);
            //this.valoresMedia.push(item);
          }
        }
      }
    });

    this.iniciarGrafico();
  }

  executarAoCarregarDatasource(x: Provimento[]) {
    console.log('Recebido provimento X[]', x);

    this.dataSource$ = this.service
      .listarPeriodoAvaliativo(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarPeriodo(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );

    this.dataSource = new MatTableDataSource<Provimento>(x);
    this.carregando = false;
  }

  atualizar() {
    this.carregando = true;
    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });
    if (this.env.servidor) {
      this.listar();
    } else {
      //this.servService.getServidorComFuncao(() => {this.listar();});
      this.servService.getServidorComFuncao2().then(() => this.listar());
    }
  }

  listar() {
    UtilLogAcessoSistema.registrarAcessoAoRecurso(
      this.recurso,
      this.env.servidor.idServidor,
      this.service
    );
    this.dataSource$ = this.service
      .listarPeriodoAvaliativo(this.env.servidor.idServidor)
      .pipe(
        tap((a) => this.executarAoCarregarDatasource(a)),
        take(1),
        catchError((e) => {
          this.handleError(e);
          return EMPTY;
        })
      );
  }

  /*
  atualizar() {
    this.carregando = true;

    this.t = timer(20000).subscribe((v) => {
      if (this.carregando) {
        this.carregando = false;
        this.handleError(
          'Excedido tempo de carregamento (' + this.constructor.name + ')'
        );
      }
    });

    this.servidor =
      this.servService.getServidorAtualRedirecionando('avaliacao');

    this.servidor$ = this.servService.getServidor().pipe(
      tap((x) => this.executarAoCarregarServidor(x)),
      take(1),
      catchError((e) => {
        this.handleError(e);
        return empty();
      })
    );

    if (this.servidor) {
      this.dataSource$ = this.service
        .listarPeriodoAvaliativo(this.servidor.idServidor)
        .pipe(
          tap((a) => this.executarAoCarregarDatasource(a)),
          take(1),
          catchError((e) => {
            this.handleError(e);
            return empty();
          })
        );

      // this.dataSource$ = this.service
      //   .listarProvimento(this.servidor.idServidor)
      //   .pipe(
      //     tap(a => this.executarAoCarregarDatasource(a)),
      //     take(1),
      //     catchError(e => {
      //       this.handleError(e);
      //       return empty();
      //     })
      //   );
    }
  }
*/
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  mostrarAjudaModal() {
    this.ajudaService.mostrar(this.itensAjuda, '');
  }

  handleError(e) {
    this.erros$.next(true);
    this.alertService.mostrarAlertaPerigo(
      'Erro, tente novamente mais tarde',
      e
    );
  }
}
